/**
 * Public links into the authenticated shells (`/dashboard`, `/portal`,
 * `/admin`) opt out of Next's Link prefetch: those routes carry the Amplify
 * Authenticator bundle (≈ 108 KB gz) that a marketing visitor may never need,
 * and in-viewport prefetch was downloading it on every landing-page visit.
 * Marketing routes keep the default prefetch (`undefined`).
 */
export function shellPrefetch(href: string): false | undefined {
  return /^\/(dashboard|portal|admin)(\/|$)/.test(href) ? false : undefined;
}
